<template>
    <v-expansion-panel v-model="panelIndex" class="notasPanel" >
        <v-expansion-panel-content class="secondary textwhite">
            <template v-slot:header>
                <div class="white--text">Filtros</div>
            </template>
            <v-layout style="background-color: white; ">
                <!--v-flex xs12 sm8 offset-sm2-->
                

                    <v-form v-model="valid" class="fullwidth">
                        <v-container grid-list-md text-xs-center pa-0>
                                    
                            <template v-for="(fecha, index) in fechas">                        
                                <v-layout 
                                :key='index'
                                v-if="index%2==0"
                                row
                                wrap                                                 
                                > 
                                <v-flex xs12 sm6 md6 >   
                                    <v-dialog
                                        ref="dialog"
                                        v-model="fechas[index].modal"
                                        :return-value.sync="fechas[index].date"
                                        persistent
                                        lazy
                                        full-width     
                                        width="290px"                           
                                        >
                                        <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="fechas[index].dateFormatted"
                                            v-bind:label="fechas[index].text"
                                            prepend-icon="event"
                                            readonly
                                            @blur="fechas[index].date = parseDate(fechas[index].dateFormatted);"                                    
                                            v-on="on"
                                        ></v-text-field>
                                        </template>
                                        <v-date-picker locale="es-ES" v-model="fechas[index].date" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="fechas[index].modal = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.dialog[index].save(fechas[index].date); fechas[index].dateFormatted = formatDate(fechas[index].date); getInvoices(selected,ignoreCust,onlyPending);">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-flex>   
                                <v-flex xs12 sm6 md6>   
                                    <v-dialog
                                        ref="dialog"
                                        v-model="fechas[index+1].modal"
                                        :return-value.sync="fechas[index+1].date"
                                        persistent
                                        lazy
                                        full-width     
                                        width="290px"                           
                                        >
                                        <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="fechas[index+1].dateFormatted"
                                            v-bind:label="fechas[index+1].text"
                                            prepend-icon="event"
                                            readonly
                                            @blur="fechas[index].date = parseDate(fechas[index].dateFormatted);"                                                                        
                                            v-on="on"
                                        ></v-text-field>
                                        </template>
                                        <v-date-picker locale="es-ES" v-model="fechas[index+1].date" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="fechas[index+1].modal = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.dialog[index+1].save(fechas[index+1].date); fechas[index+1].dateFormatted = formatDate(fechas[index+1].date); getInvoices(selected,ignoreCust,onlyPending);">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-flex>                                                   
                                </v-layout>  
                            </template>                                    
                        </v-container>  
                        <v-expansion-panel>
                        <v-expansion-panel-content
                            v-for="(item,i) in 1"
                            :key="i"
                            >
                            <template v-slot:header>
                                <div>Tipos de documento</div>
                            </template>
                            <v-card>
                                <v-card-text> 
                                    <v-container fluid>
                                        <v-layout row wrap class="light--text">
                                            <v-checkbox v-model="selected" :label="docTypes[0].doctype" :value="docTypes[0].value"></v-checkbox>
                                            <v-checkbox v-model="selected" :label="docTypes[1].doctype" :value="docTypes[1].value"></v-checkbox>
                                            <v-checkbox v-model="selected" :label="docTypes[2].doctype" :value="docTypes[2].value"></v-checkbox>
                                            <v-checkbox v-model="selected" :label="docTypes[3].doctype" :value="docTypes[3].value"></v-checkbox>
                                        </v-layout>
                                    </v-container>                            
                                </v-card-text>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-flex xs12 lg10 offset-lg1 v-if="($store.state.usuario.type == 'COMERCIAL') && (!ignoreCust)">
                            <v-text-field v-model="custFilter" label="Cliente" type="text" required></v-text-field>
                        </v-flex> 
                        <v-container
                        id="scroll-target"
                        style="max-height: 200px"
                        class="scroll-y"
                        fluid
                        pa-0
                        >                 
                        <v-flex xs12 lg10 offset-lg1 v-if="$store.state.usuario.type == 'COMERCIAL'">
                            <v-checkbox v-model="ignoreCust" label="No filtrar por cliente"></v-checkbox>
                            <v-checkbox v-model="onlyPending" label="Solo pendientes"></v-checkbox>
                            <listaClientes v-if="!ignoreCust"/>
                        </v-flex>
                        </v-container>
                                                    
                    </v-form>                        
                <!--/v-flex-->
            </v-layout> 
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
import listaClientes from '@/components/listaClientes.vue'
export default {
    data () {
        return {                        
            valid: false,
            docTypes:[{doctype:"Pedido", value:"PEDIDO"},{doctype:"Factura",value:"Factura"},{doctype:"Albarán",value:"Factura Alb."},{doctype:"Abono",value:"Abono"}],
            selected:[],
            timeout: null,
            panelIndex: 0,
            ignoreCust: false
        }
    },
    methods: {
        changeIgnoreCust(val){
            console.log(val);
        },
        getCust(){
            let auxthis = this;
            
            this.timeout = setTimeout(function () {
                auxthis.getCustomers();               
                //console.log('test');
            }, 1500);
        }
    },
    components:{
        listaClientes
    },
    computed:{
        custFilter:{
            get(){
                return this.$store.state.custFilter;
            },
            set(value){
                this.$store.commit('setCustFilter',value);
            }
        }, 
        fechas:{
            get(){
                if (!this.$store.state.appconfig.filterInvoiceDocumentDate){
                    return this.$store.state.fechas.slice(2);
                } else 
                    return this.$store.state.fechas;
            },
            set(value){
                this.$store.commit('setDates',value);                   
            }
        },
        selectedCustIndex:{
            get(){
                return this.$store.state.selectedCustIndex;
            }
        },
        onlyPending:{
            get(){
                return this.$store.state.onlyPending;
            },
            set(value){
                this.$store.commit('setOnlyPending',value);     
            }
        },
    },
    mounted(){
        for(var i = 0; i < this.fechas.length; i++){
            this.fechas[i].dateFormatted = this.formatDate(this.fechas[i].date);
        }
        this.getInvoices(this.selected, this.ignoreCust, this.onlyPending);       
    },
    watch:{
        ignoreCust: function(val){
            this.custFilter = '';
            this.getInvoices(this.selected, val, this.onlyPending); 
        },
        onlyPending: function(val){
            this.custFilter = '';
            this.getInvoices(this.selected, this.ignoreCust, val); 
        },
        panelIndex: function(val) {
            var thisAux = this;
            setTimeout(function(){
                thisAux.$vuetify.goTo(0)
            },200);
        },
        custFilter: function(val, oldVal){
            if (!this.ignoreCust) this.getCust();
        },
        selectedCustIndex: function(val, oldVal){
            this.getInvoices(this.selected, this.ignoreCust, this.onlyPending);
        },
        selected: function(val, oldVal){
            this.getInvoices(val, this.ignoreCust, this.onlyPending);
        }
    }
}
</script>
<style scoped>
.fullwidth{
    width: 100%;
}
</style>


